<template>
  <div>
    <template v-if="loading">
      <div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner :label="$t('common.loading')" />
        </div>
      </div>
    </template>
    <b-row v-else>
      <b-col cols="12" sm="12">
        <b-card :title="$t('reception.patient-card-data')">
          <div>
            <h5 class="my-2">
              <b>{{ $t("common.name") }}:</b>
              <p class="mx-2 d-inline d-inline">
                {{ patientCardData.patient.name }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.companion-name") }}:</b>
              <p class="mx-2 d-inline d-inline">
                {{ patientCardData.full_companion_name }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.companion-phone") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.companion_phone }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.next-kin-name") }}:</b>
              <p class="mx-2 d-inline d-inline">
                {{ patientCardData.next_of_kin_name }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.next-kin-phone") }}:</b>
              <p class="mx-2 d-inline d-inline">
                {{ patientCardData.next_of_kin_phone_number }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.card-type") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.type }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.smoking") }}:</b>
              <p class="mx-2 d-inline">
                {{ !patientCardData.is_smoker ? "No" : "Yes" }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.diabetic") }}:</b>
              <p class="mx-2 d-inline">
                {{ !patientCardData.has_diabetes ? "No" : "Yes" }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.heart-disease") }}:</b>
              <p class="mx-2 d-inline">
                {{ !patientCardData.has_heart_disease ? "No" : "Yes" }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.hypertension") }}:</b>
              <p class="mx-2 d-inline">
                {{ !patientCardData.has_high_blood_pressure ? "No" : "Yes" }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.weight") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.weight }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.height") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.height }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.patient-case") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.patient_case }}</p>
            </h5>
            <!-- <h5 class="my-2">
              <b>{{ $t('reception.patient-case-detalis') }}:</b>
              <p class="mx-2 d-inline">
                {{ patientCardData.patient_case_details }}
              </p>
            </h5> -->
          </div>

          <hr class="invoice-spacing" />
          <h2 class="my-2">{{ $t("reception.patient-updates") }}</h2>
          <div>
            <h5 class="my-2">
              <b>{{ $t("reception.date-of-last-update") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.updated_at }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.patient-info-created-at") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.created_at }}</p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("reception.card-no") }}:</b>
              <p class="mx-2 d-inline">{{ patientCardData.card_no }}</p>
            </h5>
          </div>
          <hr class="invoice-spacing" />
        </b-card>

        <PateintCardTest
          :isHistory="true"
          :patientCardId="patientCardData.id"
          v-if="$store.state.app.permissions.includes('get-patientCardTest')"
        />
      </b-col>
    </b-row>

    <PatentCardSurgery
      :isHistory="true"
      :patientCardId="patientCardData.id"
      v-if="patientCardData.type == 'IN'"
    />
    <PatientEmergency
      :isHistory="true"
      :patientCardId="patientCardData.id"
      v-if="patientCardData.type == 'EMERGENCY'"
    />
    <!-- <PatientDrug
      :isHistory="true"
      :patientCardId="patientCardData.id"
      v-if="
        patientCardData.type == 'IN' ||
        patientCardData.type == 'EMERGENCY' ||
        patientCardData.type == 'Clinic' ||
        patientCardData.type == 'OUT'
      "
    /> -->
    <PatientCardRadiology
      :isHistory="true"
      :patientCardId="patientCardData.id"
      v-if="
        $store.state.app.permissions.includes('get-patientCardRadiology') &&
        patientCardData.type == 'IN'
      "
    />
    <PatientOutClinicInvoice
      :isHistory="true"
      :patientCardId="patientCardData.id"
      v-if="
          patientCardData.type == 'OUT'||
        patientCardData.type == 'EMERGENCY' ||
        patientCardData.type == 'Clinic'
      "
    />

    <SurgeryInsuranceInvoice
      :isHistory="true"
      :patientCardId="patientCardData.id"
      v-if="
        $store.state.app.permissions.includes('get-invoiceInsuranceSurgery') &&
        patientCardData.type == 'IN'
      "
    />
    <Attachments :isHistory="true" :patientCardId="patientCardData.id" />
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BLink,
  BCardText,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BSpinner,
} from "bootstrap-vue";
import ReceptionHistoryCard from "@/components/reception/ReceptionHistoryCard";
import ReceptionPatientCardWithQR from "@/components/reception/ReceptionPatientCardWithQR";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import PateintCardTest from "@/views/lab/PatientCardTest.vue";
import PatentCardSurgery from "@/views/surgery/PatientSurgery.vue";
import PatientCardRadiology from "@/views/radiology/PatientCardRadiology.vue";
import PatientOutClinicInvoice from "@/views/Reception/PatientOutClinicInvoice.vue";
import SurgeryInsuranceInvoice from "@/views/surgery/SurgeryInsuranceInvoice.vue";
import PatientEmergency from "@/views/emergency/PatientEmergency.vue";
import PatientDrug from "@/views/pharmacy/PatientDrug.vue";
import Attachments from "./Attachments.vue";

import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormInput,
    BFormTextarea,
    BFormGroup,
    BSpinner,
    BCard,
    BCardText,
    Attachments,
    BButton,
    ReceptionHistoryCard,
    ReceptionPatientCardWithQR,
    StatisticCardHorizontal,
    AutoComplete,
    vSelect,
    ToastificationContent,
    PateintCardTest,
    PatentCardSurgery,
    PatientCardRadiology,
    PatientOutClinicInvoice,
    SurgeryInsuranceInvoice,
    PatientEmergency,
    VuePhoneNumberInput,
    PatientDrug,
  },
  data() {
    return {
      loading: false,
      patientCardData: {},
    };
  },

  mounted() {
    this.getPatientCard();
  },

  methods: {
    async getPatientCard() {
      this.loading = true;
      await this.getPatient(`patientCard/${this.$route.params.id}`);
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.patientCardData = this.all_data;
      console.log(this.patientCardData);
    },
  },
};
</script>
